import { render, staticRenderFns } from "./Comandero.vue?vue&type=template&id=61c35cad"
import script from "./Comandero.vue?vue&type=script&lang=js"
export * from "./Comandero.vue?vue&type=script&lang=js"
import style0 from "./Comandero.vue?vue&type=style&index=0&id=61c35cad&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports